import en from "../Translate/en.json";

export default function translate(path, ...args) {
  if (!path) {
    return;
  }

  const currentLanguage = "en";

  const keys = path.split(".");
  let language;

  switch (currentLanguage) {
    case "en":
      language = en;
      break;

    // Add more cases for other languages as needed
    default:
      language = en;
  }

  let value;
  try {
    value = keys.reduce((acc, cur) => acc[cur], language);
    return value.replace(/%s/g, () => `${args.shift()}`);
  } catch (error) {
    console.error(`Unable to parse translation path: ${path}`);
  }
}
